// extracted by mini-css-extract-plugin
module.exports = {"card":"CountCard_card__usPZ1","textColor":"CountCard_textColor__qVE3y"};